import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import LoginPage from "./LoginPage";
import RulesPage from "./RulesPage";
import RuleTesterPage from "./RuleTesterPage";
import UsersPage from "./UsersPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div style={S.loader}>Checking session…</div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

export default function AdminApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route
          path=""
          element={
            <Protected>
              <RulesPage />
            </Protected>
          }
        />
        <Route
          path="users"
          element={
            <Protected>
              <UsersPage />
            </Protected>
          }
        />
        <Route
          path="tester"
          element={
            <Protected>
              <RuleTesterPage />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </AuthProvider>
  );
}

const S = {
  loader: {
    minHeight: "100vh", background: "#0b1220", color: "#94a3b8",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontFamily: "ui-sans-serif,system-ui,-apple-system,'Segoe UI',sans-serif",
  },
};
